import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    ContextMenuItem,
    hideContextMenu,
    selectContextMenuItems,
    selectContextMenuPosition
} from "../redux/ContextMenu"
import notNull from "../util/notNull"

function ContextMenu() {
    const position = useAppSelector(selectContextMenuPosition)
    const items = useAppSelector(selectContextMenuItems)

    const dispatch = useAppDispatch()
    function onItemClick(item: ContextMenuItem) {
        item.action()
        dispatch(hideContextMenu())
    }

    return (
        <>
            {notNull(position) && (
                <div
                    style={{
                        position: "fixed",
                        left: 0,
                        top: 0,
                        marginLeft: position.x,
                        marginTop: position.y
                    }}
                    className={"bg-white shadow rounded-xl flex flex-col"}>
                    {items.map((item) => (
                        <div
                            key={item.name}
                            onClick={() => onItemClick(item)}
                            className={
                                "cursor-pointer hover:rounded-xl hover:bg-neutral-100 p-3 w-full items-center"
                            }>
                            <div
                                className={
                                    item.textStyle !== undefined
                                        ? item.textStyle
                                        : ""
                                }>
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}

export default ContextMenu
